//#region import libraries
import React, { useState, useEffect } from 'react';
//bootstrap
import { Container, Row, Col, Spinner, Button, Form } from 'react-bootstrap';
//custom component
import { Backbutton } from "_molecules";
import { Title, HoverIcon, NewScreen } from "_atoms";

import validator from 'validator';
//redux
import { useSelector, useDispatch } from 'react-redux';
import { selectFirebaseUser, changePassword, changeName, selectNameFlag, selectNameStatus, changeEmail, selectPasswordStatus, selectPasswordFlag, selectEmailStatus, selectEmailFlag } from '_redux/slices/main-screen/user';
//styles
import { Colors } from '_styles';
//#endregion

const EditAccount = (props) => {


    //#region state variables
    // state variables    
    const [firstName, setFirst] = useState('');
    const [secondName, setSecond] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [splitName, setSplitName] = useState(["", ""])

    // editing enabled vars
    const [firstEnabled, setFirstEnabled] = useState(true);
    const [emailEnabled, setEmailEnabled] = useState(true);
    const [passwordEnabled, setPasswordEnabled] = useState(true);
    // errors
    const [errors, setErrors] = useState({});
    const [nameErrors, setNameErrors] = useState({});
    const [passwordErrors, setPasswordErrors] = useState({});
    const [emailErrors, setEmailErrors] = useState({});
    //#endregion

    //#region redux
    const dispatch = useDispatch();
    const firebaseUser = useSelector(selectFirebaseUser);
    const nameStatus = useSelector(selectNameStatus)
    // status
    const passwordStatus = useSelector(selectPasswordStatus)
    const emailStatus = useSelector(selectEmailStatus)

    const nameFlag = useSelector(selectNameFlag);
    const passwordFlag = useSelector(selectPasswordFlag);
    const emailFlag = useSelector(selectEmailFlag);
    //#endregion

    //#region functions
    //submit password
    const submitPassword = () => {

        let errors = {};
        let invalid = false;

        if (password.length == 0) {
            errors.password = "Please enter your new password";
            invalid = true
        }
        if (password != confirmPassword) {
            errors.password = "Passwords do not match";
            invalid = true
        }
        if (confirmPassword.length == 0) {
            errors.confirmPassword = "Please enter your password again";
            invalid = true
        }
        if (!validator.isStrongPassword(password)) {
            errors.password = "Password length must be at least eight letters and have one capital letter, one symbol and one number";
            invalid = true
        }
        if (invalid) {
            setPasswordErrors(errors)
        }
        else {
            dispatch(changePassword(password))
        }
    }

    //submit Name
    const submitName = () => {

        let errors = {};
        let invalid = false;

        if (firstName.length == 0) {
            errors.firstName = "First name cannot be empty";
            invalid = true
        }
        if (secondName.length == 0) {
            errors.secondName = "Second name cannot be empty";
            invalid = true
        }
        if (invalid == true) {
            setNameErrors(errors);
            return
        }
        else {
            dispatch(changeName(firstName + ' ' + secondName))
        }
    }
    //submit email
    const submitEmail = () => {
        if (!validator.isEmail(email)) {
            setEmailErrors({ email: "Please enter a valid email" })
        }
        else {
            dispatch(changeEmail(email))
        }
    }
    //#endregion

    // reset on intialize
    useEffect(() => {
        setErrors({})
        // ERROR logs out
        // dispatch(resetStatus())

        // split name
        if (firebaseUser && firebaseUser.displayName) {
            let splitter = firebaseUser.displayName.split(' ')
            setSplitName(splitter)
        }
    }, []);

    return (
        <>
            <NewScreen>
                <Container fluid={true}>
                    <Row>

                        {/* Title & Subtitle */}
                        <Title name="Account" />
                        <Backbutton page='account' />

                        <p className="mt-3" style={{ fontSize: 26, fontWeight: 'bold' }}>Edit Account</p>
                        <div className="mt-3" style={{}}>
                            <p style={{ fontSize: 18, fontWeight: '600', opacity: 0.6 }}>Edit Account</p>
                        </div>

                        {/* Form */}
                        <Col>
                            <Form>
                                <Form.Group>
                                    <Row>

                                        {/* First & Second Name */}
                                        <Col>

                                            {/* First Name */}
                                            <HoverIcon label={'First Name'} onClick={() => { setFirstEnabled(!firstEnabled) }} />
                                            <Form.Control onChange={(e) => setFirst(e.target.value)} type="name" placeholder={splitName[0]} disabled={firstEnabled} />
                                            {
                                                nameErrors.firstName && (
                                                    <p className="text-danger">{nameErrors.firstName}</p>
                                                )
                                            }

                                            {/* Second Name */}
                                            <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 4 }}>Second Name</Form.Label>
                                            <Form.Control onChange={(e) => setSecond(e.target.value)} type="name" placeholder={splitName[1]} disabled={firstEnabled} />
                                            {
                                                nameErrors.secondName && (
                                                    <p className="text-danger">{nameErrors.secondName}</p>
                                                )
                                            }

                                            {/* Submit Button */}
                                            {
                                                <>
                                                    <Button variant={firstEnabled ? 'outline-primary' : nameStatus == 'succeeded' ? 'outline-success' : "outline-danger"} onClick={firstEnabled ? () => { setFirstEnabled(false) } : () => { setFirstEnabled(true) }} loading={true} style={{ width: 175 }} className="mt-5">
                                                        {firstEnabled ? 'Edit Name' : nameStatus == 'succeeded' ? 'Done' : "Cancel"}
                                                    </Button>
                                                </>
                                            }
                                            {
                                                firstEnabled == false ?
                                                    <Button variant={nameStatus == 'succeeded' ? 'outline-success' : "outline-primary"} onClick={submitName} loading={true} style={{ width: 175, marginLeft: 28 }} className="mt-5" disabled={nameStatus == 'succeeded' ? true : false}>
                                                        {
                                                            nameStatus == 'idle' ?
                                                                'Edit Name'
                                                                :
                                                                nameStatus == 'succeeded' ?
                                                                    'Successful'
                                                                    :
                                                                    <Spinner
                                                                        as="span"
                                                                        animation="border"
                                                                        size="sm"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                    />
                                                        }
                                                    </Button>
                                                    :
                                                    " "
                                            }
                                            {
                                                nameFlag &&
                                                (
                                                    <p className="text-danger">{nameFlag}</p>
                                                )
                                            }
                                        </Col>

                                        {/* Password  & Confirm Password */}
                                        <Col style={{ marginLeft: 100 }}>
                                            <HoverIcon label={'Change Password'} onClick={() => { setPasswordEnabled(!passwordEnabled) }} />
                                            <Form.Control onChange={(e) => setPassword(e.target.value)} type="password" placeholder="Password" disabled={passwordEnabled} />
                                            {
                                                passwordErrors.password && (
                                                    <p className="text-danger">{passwordErrors.password}</p>
                                                )
                                            }

                                            {/* Confirm Password */}
                                            <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, marginTop: 4 }}>Confirm Password</Form.Label>
                                            <Form.Control onChange={(e) => setConfirmPassword(e.target.value)} type="text" placeholder="Confirm Password" disabled={passwordEnabled} />
                                            {
                                                passwordErrors.confirmPassword && (
                                                    <p className="text-danger">{passwordErrors.confirmPassword}</p>
                                                )
                                            }

                                            {/* Submit Password Button */}
                                            {
                                                <>
                                                    <Button variant={passwordEnabled ? 'outline-primary' : passwordStatus == 'succeeded' ? 'outline-success' : "outline-danger"} onClick={passwordEnabled ? () => { setPasswordEnabled(false) } : () => { setPasswordEnabled(true) }} loading={true} style={{ width: 175 }} className="mt-5">
                                                        {passwordEnabled ? 'Edit Password' : "Cancel"}
                                                    </Button>
                                                </>
                                            }
                                            {
                                                passwordEnabled == false ?
                                                    <Button variant={passwordStatus == 'succeeded' ? 'outline-success' : passwordStatus == 'failed' ? 'outline-danger' : "outline-primary"} onClick={submitPassword} loading={true} style={{ width: 175, marginLeft: 28 }} className="mt-5">
                                                        {
                                                            passwordStatus == 'idle' ?
                                                                'Edit Password'
                                                                :
                                                                passwordStatus == 'succeeded' ?
                                                                    'Successful'
                                                                    :
                                                                    passwordStatus == 'failed' ?
                                                                        'Failed'
                                                                        :
                                                                        <Spinner
                                                                            as="span"
                                                                            animation="border"
                                                                            size="sm"
                                                                            role="status"
                                                                            aria-hidden="true"
                                                                        />
                                                        }
                                                    </Button>
                                                    :
                                                    ""
                                            }
                                            {
                                                passwordFlag &&
                                                (
                                                    <p className="text-danger">{passwordFlag}</p>
                                                )
                                            }

                                        </Col>



                                    </Row>
                                </Form.Group>

                                {/* Email */}
                                <Form.Group className="mt-4">
                                    <Col>
                                        <Row style={{ width: '40%' }}>
                                            <Col>
                                                <HoverIcon label={'Email'} onClick={() => { setEmailEnabled(!emailEnabled) }} />
                                                <Form.Control onChange={(e) => setEmail(e.target.value)} type="name" placeholder={firebaseUser.email} disabled={emailEnabled} />
                                                {
                                                    emailErrors.email && (
                                                        <p className="text-danger">{emailErrors.email}</p>
                                                    )
                                                }
                                            </Col>
                                        </Row>
                                        {
                                            <>
                                                <Button variant={emailEnabled ? 'outline-primary' : emailStatus == 'succeeded' ? 'outline-success' : "outline-danger"} onClick={emailEnabled ? () => { setEmailEnabled(false) } : () => { setEmailEnabled(true) }} loading={true} style={{ width: 175 }} className="mt-5">
                                                    {emailEnabled ? 'Edit Email' : emailStatus == 'succeeded' ? 'Done' : "Cancel"}
                                                </Button>
                                            </>
                                        }
                                        {
                                            emailEnabled == false ?
                                                <Button variant={emailStatus == 'succeeded' ? 'outline-success' : emailFlag ? 'outline-danger' : "outline-primary"} onClick={submitEmail} loading={true} style={{ width: 175, marginLeft: 28 }} className="mt-5">
                                                    {
                                                        emailStatus == 'idle' ?
                                                            'Edit Email'
                                                            :
                                                            emailStatus == 'succeeded' ?
                                                                'Successful'
                                                                :
                                                                emailStatus == 'failed' ?
                                                                    'Failed'
                                                                    :
                                                                    <Spinner
                                                                        as="span"
                                                                        animation="border"
                                                                        size="sm"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                    />
                                                    }
                                                </Button>
                                                :
                                                ""
                                        }
                                        {
                                            emailFlag &&
                                            (
                                                <p className="text-danger">{emailFlag}</p>
                                            )
                                        }
                                    </Col>

                                </Form.Group>

                            </Form>

                        </Col>

                    </Row>
                </Container>
            </NewScreen>
        </>
    )
}

export default EditAccount;